module.exports = __webpack_public_path__ + "39a58a3cf2b0371c7dbf4e9db8d45b3b.svg";